module.exports = __webpack_public_path__ + "img/icon-scan-terminal-green@3x.2c597ae6.png";